import { config } from "@/config";
export class PagoService {
    /**
     * 1️⃣ Registrar un pago (cliente)
     */
    static async registrarPago(dto) {
        const endpoint = `${config.API_URL}/api/Pago/registrar`;
        const formData = new FormData();
        formData.append("PedidoId", dto.pedidoId.toString());
        formData.append("MetodoPago", dto.metodoPago);
        formData.append("Comprobante", dto.comprobante, dto.comprobante.name);
        formData.append("Nombre", dto.nombre);
        formData.append("Whatsapp", dto.whatsapp);
        formData.append("Calle", dto.calle);
        formData.append("Referencia", dto.referencia);
        formData.append("Latitud", dto.latitud.toString());
        formData.append("Longitud", dto.longitud.toString());
        formData.append("UbicacionFinalizada", dto.ubicacionFinalizada.toString());
        const response = await fetch(endpoint, {
            method: "POST",
            headers: {
                Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
            },
            body: formData,
        });
        if (!response.ok) {
            let errorBody;
            try {
                errorBody = await response.json();
            }
            catch {
                throw new Error(`Error ${response.status}: Error al registrar el pago.`);
            }
            const errorMessage = errorBody?.message ||
                errorBody?.errores ||
                `Error ${response.status} en el servidor.`;
            throw new Error(errorMessage);
        }
        return response.json();
    }
    /**
     * 2️⃣ Obtener todos los pagos pendientes (Admin)
     */
    static async obtenerPagosPendientes() {
        const endpoint = `${config.API_URL}/api/Pago/pendientes`;
        const response = await fetch(endpoint, {
            method: "GET",
            headers: {
                Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
                "Content-Type": "application/json",
            },
        });
        if (!response.ok) {
            let errorBody;
            try {
                errorBody = await response.json();
            }
            catch {
                throw new Error(`Error ${response.status}: Error al obtener pagos pendientes.`);
            }
            const errorMessage = errorBody?.message ||
                errorBody?.errores ||
                `Error ${response.status} en el servidor.`;
            throw new Error(errorMessage);
        }
        return response.json();
    }
    /**
     * 3️⃣ Verificar/Aceptar o Rechazar un pago (Admin)
     * @param pagoId ID del pago a verificar
     * @param aceptar true = aceptar pago | false = rechazar pago
     */
    static async verificarPago(pagoId, aceptar) {
        const endpoint = `${config.API_URL}/api/Pago/verificar/${pagoId}?aceptar=${aceptar}`;
        const response = await fetch(endpoint, {
            method: "PUT",
            headers: {
                Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
            },
        });
        if (!response.ok) {
            let errorBody;
            try {
                errorBody = await response.json();
            }
            catch {
                throw new Error(`Error ${response.status}: Error al verificar pago.`);
            }
            const errorMessage = errorBody?.message ||
                errorBody?.errores ||
                `Error ${response.status} en el servidor.`;
            throw new Error(errorMessage);
        }
        return response.json();
    }
    /**
   * 4️⃣ Obtener historial de pagos (Admin)
   */
    static async obtenerHistorialPagos() {
        const endpoint = `${config.API_URL}/api/Pago/historial`;
        const response = await fetch(endpoint, {
            method: "GET",
            headers: {
                Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
                "Content-Type": "application/json",
            },
        });
        if (!response.ok) {
            let errorBody;
            try {
                errorBody = await response.json();
            }
            catch {
                throw new Error(`Error ${response.status}: Error al obtener historial de pagos.`);
            }
            const errorMessage = errorBody?.message ||
                errorBody?.errores ||
                `Error ${response.status} en el servidor.`;
            throw new Error(errorMessage);
        }
        return response.json();
    }
}
